import { normalizeReportTableDataForExport } from "./Functions"

//==============================================================================
//Exports report data to CSV
//==============================================================================
export const exportToCSV = async (reportDefRef, reportTableColumns, rawReportTableData, outputOption = "download") => {
  let filename = 'Untitled_Report'
  if (reportDefRef?.reportName !== '' && reportDefRef !== undefined) {
    filename = reportDefRef?.reportName
  }
  let ShowLabel = false

  //Load an array using reportTableData (antd table extra.currentDataSource object).  reportData filtered and sorted in table.
  //currentDataSource includes __typedef column and does not guarantee proper column order (? not positive about column order).
  //Following removes __typedef property and puts column data in order as displayed in UI.
  //const headerNames = reportTableColumns.map(column => column.title.props.children) //Before tooltipText added to header
  const headerNames = reportTableColumns.map(column => column.title.props.children[1].props.children)

  const fieldNames = reportTableColumns.map(column => column.dataIndex)

  //Normalize report data for export.  Format dates, numbers, join arrays, strip markup codes, etc.
  const reportTableData = await normalizeReportTableDataForExport(rawReportTableData, reportDefRef)
  
  let csvData = []
  if (headerNames) {
    csvData.push(headerNames)
  }
  if (reportTableData !== undefined) {
    for (const dataRow of reportTableData) {
      let newRow = []
      for (const field of fieldNames) {
        newRow.push(dataRow[field])
      }
      csvData.push(newRow)
    }
  } else {
    for (const dataRow of reportData) {
      let newRow = []
      for (const field of fieldNames) {
        newRow.push(dataRow[field])
      }
      csvData.push(newRow)
    }
  }

  //If reportData is not an object then JSON.parse will parse the JSON string in an Object
  if (csvData !== undefined) {
    var arrData = typeof csvData != 'object' ? JSON.parse(csvData) : csvData
  }
  // if (reportData !== undefined) {
  //   var arrData =
  //     typeof reportData != 'object' ? JSON.parse(reportData) : reportData
  // }

  var CSV = ''
  //This condition will generate the Label/Header
  if (ShowLabel && arrData?.length > 0) {
     var row = ''

    //This loop will extract the label from 1st index of on array
    for (var index in arrData[0]) {
      //Now convert each value to string and comma-seprated
      row += index + ','
    }
    row = row.slice(0, -1)
    //append Label row with line break
    CSV += row + '\r\n'
  }

  //1st loop is to extract each row
  for (var i = 0; i < arrData?.length; i++) {
    var row = ''
    //2nd loop will extract each column and convert it in string comma-seprated
    for (var index in arrData[i]) {
      row += '"' + arrData[i][index] + '",'
    }
    row.slice(0, row?.length - 1)
    //add a line break after each row
    CSV += row + '\r\n'
  }

  if (CSV == '') {
    alert('Invalid Data')
    return
  }
  if (outputOption == 'download') {
    var link = document.createElement('a')
    link.id = 'lnkDwnldLnk'

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link)

    var csv = CSV
    var link = document.createElement('a')
    link.setAttribute(
    'href',
    'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv)
    )
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  if (outputOption === 'blob') {
    const csvBlob = new Blob([CSV], {
    type: 'application/pdf'
    })
    return await csvBlob.text() //utf-8 text of pdf content
    // //var csv = CSV
  }
  //this trick will generate a temp "a" tag
}
